'use client';

import { useState } from 'react';

import {
    Alignable,
    Columns,
    Headline,
    HeadlineLevel,
    HeadlineMarkup,
    IconName,
    Modal,
    Spacer,
    SpacerSize,
    Title,
    TypographyAlign,
    View,
} from '@bytel/trilogy-react-ts';

import fetchHtml from '@services/cms/fetch-html';
import { getAppConfig } from '@services/config';

import { MobileAndFaiFaqType } from 'src/app/(landing)/forfaits-mobiles/sans-engagement/page';

import { Faq } from '../../faq';
import FinePrint from './fine-print';
import HomeBreadcrumb from './home-breadcrumb';
import ReasonItem from './reason-item';

type PageBottomContentProps = {
    mobilePlanFirst: boolean;
    faqs: MobileAndFaiFaqType;
};
export default function PageBottomContent({ mobilePlanFirst, faqs }: PageBottomContentProps) {
    const [shouldShowMentionsModal, setShouldShowMentionsModal] = useState(false);
    const [mentionModalContent, setMentionModalContent] = useState('');
    const appConf = getAppConfig();

    const handleOpenModal = async () => {
        try {
            const html = await fetchHtml(
                `${appConf.assets.partials.url}/mentions_legales/emplacements/forfaits-mobiles_sans-engagement`,
            );
            setMentionModalContent(html);
            setShouldShowMentionsModal(true);
        } catch {
            setShouldShowMentionsModal(false);
        }
    };
    const content = [
        {
            title: mobilePlanFirst ? 'Votre forfait disponible instantément' : 'Une installation rapide et gratuite',
            content: mobilePlanFirst
                ? "Avec la eSIM, plus besoin d'attendre la livraison de la carte SIM. Juste après la souscription, activez votre forfait directement depuis votre application ou votre espace client, et le tour est joué."
                : "Choisissez un RDV qui vous arrange, on s'occupe du reste ! Tout est gratuit : la livraison de la box en point relais, le raccordement à la fibre...",
            iconName: mobilePlanFirst ? IconName.STOPWATCH : IconName.V_SIGN,
        },
        {
            title: mobilePlanFirst ? "On s'occupe pour vous de la résiliation" : 'Vos frais de résiliation remboursés',
            content: mobilePlanFirst
                ? "Gardez votre numéro actuel : non seulement c'est gratuit, mais en plus, on s'occupe de résilier votre contrat auprès de votre opérateur mobile."
                : 'Votre opérateur internet vous demande des frais pour résilier votre box actuelle ? On vous les rembourse à hauteur de 50€ sur simple demande.',
            iconName: mobilePlanFirst ? IconName.V_SIGN : IconName.GIFT,
        },
        {
            title: "Une assistance 7j/7 via l'appli",
            content: mobilePlanFirst
                ? 'Un problème? Pas de problème ! Ouvrez votre application Bouygues Telecom, et accédez à une assistance disponible 24h/24.'
                : 'Un problème ? Pas de problème ! Ouvrez votre application Bouygues Telecom, et accédez à une assistance disponible 24h/24 et par téléphone les 2 premiers mois.',
            iconName: IconName.HAND_MOBILE,
        },
    ];

    return (
        <>
            <View className='mwdapp ac'>
                <Headline
                    className='has-text-centered has-text-blue-byou'
                    typo={Alignable.ALIGNED_CENTER}
                    markup={HeadlineMarkup.H2}
                    level={HeadlineLevel.LEVEL3}
                >
                    Trois raisons de choisir {mobilePlanFirst ? 'un forfait' : 'une box'} B&YOU
                </Headline>
                <Columns>
                    {content.map((reason) => (
                        <ReasonItem
                            key={reason.title}
                            title={reason.title}
                            content={reason.content}
                            iconName={reason.iconName}
                        />
                    ))}
                </Columns>

                <Faq faqs={faqs} isMobilePlan={mobilePlanFirst} />

                <View className='has-text-centered mt-2'>
                    <a
                        className='link button-clear has-text-tertiary eventTextColor'
                        title='Infos légales'
                        aria-label='Mentions légales'
                        onClick={handleOpenModal}
                    >
                        Mentions légales
                    </a>
                </View>

                <FinePrint />
                <Spacer size={SpacerSize.LARGE} />
                <HomeBreadcrumb />
            </View>

            <Modal active={shouldShowMentionsModal} onClose={() => setShouldShowMentionsModal(false)} closeIcon>
                <Title typo={TypographyAlign.TEXT_LEFT}>Mentions légales</Title>
                <div className='has-text-left' dangerouslySetInnerHTML={{ __html: mentionModalContent }} />
            </Modal>
        </>
    );
}
